import { NgFor, NgIf } from '@angular/common';
import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CompanyTypesService } from '../../../Services/Data Service/companytypes.service';
//import { FormDataService } from '../../../Services/Form Data /form-data.service';
import { ACustomerInfoComponent } from '../a-customer-info/a-customer-info.component';
import { FormDataService } from '../../../Services/Form Data/form-data.service';
import { DataService } from '../../../Services/Data Service/data.service';
import { firstValueFrom, forkJoin, switchMap, take } from 'rxjs';
import { AuthService } from '../../../Auth/auth.service';
import { FormUpdateService } from '../../../Services/Form Data/formupdate.service';
import { FormSubmitService } from '../../../Services/Form Data/formsubmit.service';
import { DisableAutocompleteDirective } from '../../../disable-autocomplete.directive';

@Component({
  selector: 'app-b-category-form',
  standalone: true,
  imports: [FormsModule, NgIf, NgFor, DisableAutocompleteDirective],
  templateUrl: './b-category-form.component.html',
  styleUrl: './b-category-form.component.css'
})
export class BCategoryFormComponent {
  @Input() isViewOnly: boolean = false;
  @Input() formData: any; 
    
  orgType: any;
  busTypes: string[] = [];

  //IF User enters their own:
  uniqueOrgType = '';
  uniqueBusType = '';

  loading = false;
  errorLoading = false;
  error = '';

  currUser: any;
  company: any;
  exists = false;
  savedMessage = '';

  businessOptions: { label: string; value: any }[] = [];
  orgOptions: { label: string; value: any }[] = [];


  constructor(private typesDataService: CompanyTypesService, 
    private formDataService: FormDataService, 
    private formSubmitService: FormSubmitService,
    private formUpdateService: FormUpdateService,
    private parentComponent: ACustomerInfoComponent,
    private dataService: DataService, 
    private auth: AuthService
  ) {
    // console.log("Company in b: ", this.company)
    // console.log(this.orgType);
    // console.log(this.busTypes);
  }

  ngOnInit(): void {
    this.currUser = this.formDataService.getUserData();
  
    this.errorLoading = false;
    this.loading = true;
  
    forkJoin({
      businessTypes: this.typesDataService.getBusinessTypes(),
      orgTypes: this.typesDataService.getOrgTypes(),
      updatedCompany: this.dataService.getCompanyByPK(this.formDataService.getCurrCompanyID()),  
      updatedBusTypes: this.dataService.getCompanyBusinessTypes(this.formDataService.getCurrCompanyID()) 
    }).subscribe({
      next: ({ businessTypes, orgTypes, updatedCompany, updatedBusTypes }) => {
        this.businessOptions = businessTypes.map(t => ({
          value: Number(t.value),
          label: t.label
        }));
  
        this.orgOptions = orgTypes.map(t => ({
          value: Number(t.value),
          label: t.label
        }));
  
        // Update the formData with fresh DB data
        this.formData.company = updatedCompany;
        this.formData.companyBusTypes = updatedBusTypes;
  
        this.processFormData(); // now will use fresh data
      },
      error: (err) => {
        this.handleError(err);
        console.error('Failed to load business or organization types:', err);
      }
    });
  
    this.loading = false;
  }
  

  getOrgTypeByFK(pk: number | string): string | null {
    if (!this.orgOptions) return 'Unknown';
    const fullOrgList = [...this.orgOptions, { label: 'Other', value: 99 }];
    const match = fullOrgList.find(opt => Number(opt.value) === Number(pk));
    if (match) return match.label;

    // If pk is 1 and not found in options, return null instead of 'Unknown'
    if (Number(pk) === 1) return '';
  
    return 'Unknown';
  }
      
  getBusinessTypeByFK(pk: number | string): string {
    // console.log("Looking for business type with FK:", pk, "in", this.businessOptions);

    if (!this.businessOptions) return 'Unknown';
    const fullBusinessTypeList = [...this.businessOptions, { label: 'Other', value: 99 }];
    const match = fullBusinessTypeList.find(opt => Number(opt.value) === Number(pk));
    return match ? match.label : 'Unknown';
  }
  
  getOrgTypeFKByLabel(label: string): number | null {
    if (!this.orgOptions) return null;
    const fullOrgList = [...this.orgOptions, { label: 'Other', value: 99 }];
    const match = fullOrgList.find(opt => opt.label === label);
    return match ? match.value : null;
  }  

    
  processFormData() {
    const company = this.formData.company || {};
    const orgFK = company.intCompanyOrgTypeFK;
    const otherType = company.strOtherOrgType;
  
    this.orgType = (orgFK === null || orgFK === undefined)
      ? otherType || 'Unknown'
      : this.getOrgTypeByFK(orgFK);
  
    const types = this.formData.companyBusTypes || [];
    console.log("[processFormData].. ", orgFK, otherType, types);

    this.busTypes = types.map((typeObj: any) => {
      const fk = typeObj.intCompanyTypeFK;
      const other = typeObj.strOtherType;
      const label = (fk === null || fk === undefined)
      ? other
      : this.getBusinessTypeByFK(fk);
    
      return label || 'Unknown';
    });
  }
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['formData'] && this.formData && this.businessOptions.length) {
      this.processFormData();
    }
  }  
  
  handleError(error: any) {
    this.errorLoading = true;
    console.error('SSR: Error occurred', error);
    this.loading = false;
  }

  //Validators
  validatefields(): boolean {
    console.log("Organization Type: ", this.orgType, this.uniqueOrgType);
    console.log("Business Type: ", this.busTypes);
    
    if (!this.orgType) {
      this.parentComponent.updateErrorMsg("Select Type of Organization."); 
      return false;
    }

    if (this.busTypes.length === 0) {
      this.parentComponent.updateErrorMsg("Select at least one business type."); 
      return false;
    }

    if (this.orgType == 'Other' && !this.uniqueOrgType){
      this.parentComponent.updateErrorMsg("Please enter details for organization type.");
      return false;
    }

    if (this.busTypes.includes('Other') && !this.uniqueBusType){
      this.parentComponent.updateErrorMsg("Please enter details for 'Other' business type.");
      return false;
    }

    this.parentComponent.updateErrorMsg("");
    return true;
  }

  showOtherInput = false;

  updateSelectedOptions(event: Event) {
    const selectedOptions = (event.target as HTMLSelectElement).selectedOptions;
    const selectedValues = Array.from(selectedOptions).map(option => option.value);

      // Check if "Other" is selected
      if (selectedValues.includes("Other")) {
        this.showOtherInput = true; // Show input field
        selectedValues.splice(selectedValues.indexOf("Other"), 1); // Remove "Other" from selections
      }

    this.busTypes = [...new Set([...this.busTypes, ...selectedValues])];
    console.log(this.busTypes);
}
  
  removeType(index: number): void {
    this.busTypes.splice(index, 1);  // Remove the item at the specified index
  }

  removeOrgType(): void {
    this.orgType = '';  
  }

  saveOrg() {
    if (this.uniqueOrgType.trim() !== '') {
      this.orgType = this.uniqueOrgType;
  
      this.formDataService.updatestrOtherOrgType(this.orgType);
  
      // Log the updated orgType to verify
      console.log('Updated orgType:', this.orgType);
    } else {
      console.log('Failed to provide valid details for organization type');
    }
  }
  
  
  async submit(): Promise<boolean> {
  if (!this.validatefields()) {
    return false; // Validation failed
  }

  this.loading = true;
  this.error = ""; // Clear any previous error

  try {
    // Update local form data
    if (this.uniqueOrgType && this.uniqueOrgType.trim() !== '') {
      this.formDataService.updatestrOtherOrgType(this.uniqueOrgType);
    } else {
      const orgTypeId = this.getOrgTypeFKByLabel(this.orgType);
      this.formDataService.setintCompanyOrgTypeFK(orgTypeId);
    }

    if (this.uniqueBusType && this.uniqueBusType.trim() !== '') {
      if (!this.busTypes.includes(this.uniqueBusType)) {
        this.busTypes.push(this.uniqueBusType);
      }
    }

    this.formDataService.updateCompanyBusType([...this.busTypes]);

    // Save to database
    await firstValueFrom(
      forkJoin([
        this.formUpdateService.updateCompany(this.formDataService.getCurrCompanyID()),
        this.formSubmitService.submitBusinessTypes(this.formDataService.getCurrCompanyID())
      ])
    );

    this.savedMessage = "Changes saved!";
    this.processFormData();
    this.loading = false;
    return true;
  } catch (error) {
    this.error = "There was an issue saving. Please try again.";
    this.savedMessage = "";
    this.loading = false;
    return false;
  }
}



}
